export const formatPercentage = (value: number | string): string =>
  `${(Number(value) * 100).toFixed(2).replace('.', ',')}%`;
